// Frog Garden Theme - Cute frogs on lily pads with lotus flowers - dark only
const frogGarden = {
    id: "frogGarden",
    name: "Sammakkopuutarha 🐸",
    price: 200,
    main: "#4a9e7c",
    light: "#7cc9a8",
    dark: "#2d6b54",
    bg: "#e8f5e9",
    darkBg: "#1a3d3d",
    contrastText: "#ffffff",
    isSuper: true,
    isDarkTheme: true,
    shape: "rounded",
    surfaces: {
        // Light mode (dark-only, fallback)
        lightBg: '#1a3d3d',
        lightPaper: '#2d5a5a',
        lightContainer: '#2d5a5a',
        lightOnSurface: '#f0f0f0',
        lightOnSurfaceVariant: '#a0d0c0',
        lightOutline: '#5a9a8a',
        // Dark mode
        containerLowest: '#1a3d3d',
        containerLow: '#132e2e',
        container: '#1a3d3d',
        containerHigh: '#2d5050',
        containerHighest: '#3a6060',
        bright: '#4a7070',
        onSurface: '#d4efe8',
        onSurfaceVariant: '#a0d0c0',
        outline: '#5a9a8a',
        outlineVariant: '#5a9a8a',
        // Button colors — primary
        primaryContainer: '#7cc9a8',
        onPrimaryContainer: '#1a3d3d',
        primaryText: '#fde7ff',
        primaryTextLight: '#fde7ff',
        // Button colors — secondary (outlined)
        secondaryContainer: '#1a4040',
        onSecondaryContainer: '#a0d0c0',
        // Button colors — secondary (filled)
        secondary: '#7cc9a8',
        onSecondary: '#5a9a8a',
        secondaryLight: '#2d6b54',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#d8fff0',
        onInverseSurface: '#0f2828',
        inverseSurfaceLight: '#0f2828',
        onInverseSurfaceLight: '#d8fff0',
        // Button colors — label/text
        labelColor: '#7cc9a8',
        labelColorLight: '#2d6b54',
        // Status colors
        success: '#7cc9a8',
        successLight: '#a0e0c8',
        successDark: '#2d6b54',
        warning: '#ed6c02',
        warningLight: '#ff9800',
        warningDark: '#e65100',
        error: '#ef5350',
        errorLight: '#ff7961',
        errorDark: '#c62828',
    },
    animations: {
        avatar: "float",
        taskComplete: "profileEffect",
        completionGlow: true,
        buttonHover: "shimmer",
    },
    effects: {
        glowColor: "#7cc9a850",
    },
    profileHeader: {
        bgSrc: "/uploads/profile-effects/frog-garden/frogs_top.png",
        fgSrc: "/uploads/profile-effects/frog-garden/frogs.png",
        height: { mobile: 200, tablet: 250 },
        paddingTop: { mobile: 82, tablet: 97 },
        cardPaddingTop: 30,
        cardGradient: "linear-gradient(160deg, #4a9e7c 0%, #264747 60%)",
    },
    defaultBackground: "/uploads/profile-effects/frog-garden/bg.png",
    modes: {
        light: {
            bg: "#1a3d3d",
            background: "linear-gradient(180deg, #2d5a5a 0%, #1a3d3d 40%, #0f2828 100%)",
            cardBg: "rgba(26, 61, 61, 0.85)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            taskCompleteBg: "transparent",
            taskCompleteBackground: "linear-gradient(180deg, #4a9e7c 0%, #2d6b54 100%)",
            coinCompletedBg: "rgba(74, 158, 124, 0.6)",
            coinPendingBg: "rgba(74, 158, 124, 0.5)",
            coinPendingText: "#ffffff",
            taskFontWeight: 600,
            completedByOtherBg: "rgba(255,255,255,0.08)",
        },
        dark: {
            bg: "#0f2828",
            background: "linear-gradient(180deg, #2d5a5a 0%, #1a3d3d 40%, #0f2828 100%)",
            cardBg: "rgba(26, 61, 61, 0.85)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            taskCompleteBg: "transparent",
            taskCompleteBackground: "linear-gradient(180deg, #4a9e7c 0%, #2d6b54 100%)",
            coinCompletedBg: "rgba(74, 158, 124, 0.6)",
            coinPendingBg: "rgba(74, 158, 124, 0.5)",
            coinPendingText: "#ffffff",
            taskFontWeight: 600,
            completedByOtherBg: "rgba(255,255,255,0.08)",
        },
    },
};

export default frogGarden;
